<style>
ul.step-items {
  list-style-type: none !important;
}
</style>

<template>
  <section class="container box">
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>

    <!-- <pre>{{ travelPolicy }}</pre> -->

    <div class="ml-4 my-3">
      <nav
        class="breadcrumb is-medium has-arrow-separator"
        aria-label="breadcrumbs"
      >
        <ul>
          <li><a href="/admin/travel-policy"> Travel Policy</a></li>
          <li class="is-active">
            <a href="#" aria-current="page">Create a Travel Policy</a>
          </li>
        </ul>
      </nav>
    </div>

    <b-steps
      type="is-primary"
      size="is-small"
      v-model="activeStep"
      :animated="isAnimated"
      :rounded="isRounded"
      :has-navigation="hasNavigation"
      :label-position="labelPosition"
      :mobile-mode="mobileMode"
    >
      <b-step-item step="1" label="Basic Details">
        <BasicDetails
          @basicDetails="getBasicDetails"
          :travelPolicy="sfTravelPolicy"
          :cardOptions="corporateGhostCardOptions"
        />
      </b-step-item>

      <b-step-item step="2" label="Actions">
        <Actions @actionsData="getActionData" :travelPolicy="sfTravelPolicy" />
      </b-step-item>

      <b-step-item step="3" label="Standard Rules">
        <Rules @rules="getRules" :travelPolicy="sfTravelPolicy" />
      </b-step-item>

      <b-step-item step="4" label="Custom Rules">
        <CustomRules @rules="getCustomRules" :travelPolicy="sfTravelPolicy" />
      </b-step-item>

      <b-step-item step="5" label="Summary">
        <Summary :travelPolicy="travelPolicy" />
        <br />
        <!--<b-button type="is-primary" class="is-pulled-right" @click="save">
          Save Policy
        </b-button> -->
      </b-step-item>
    </b-steps>

    <div>
      <b-button
        class="is-pulled-left ml-2"
        size="is-medium"
        outlined
        type="is-primary"
        :disabled="activeStep === 0"
        @click="handleActiveStep(-1)"
      >
        Previous
      </b-button>
      &nbsp;
      <b-button
        v-if="activeStep !== 4"
        class="is-pulled-right mr-2"
        size="is-medium"
        outlined
        type="is-primary"
        :disabled="activeStep === 4"
        @click="handleActiveStep(1)"
      >
        Next
      </b-button>

      <b-button 
        v-if="activeStep === 4" 
        type="is-primary" 
        class="is-pulled-right mr-2" 
        size="is-medium"
        outlined
        @click="save"
      >
          Save Policy
        </b-button>
    </div>
    <br />
  </section>
</template>
<script>
import BasicDetails from "./BasicDetails.vue";
import Rules from "./Rules.vue";
import CustomRules from "./CustomRules.vue";
import Actions from "./Actions.vue";
import Summary from "./Summary.vue";
export default {
  name: "TravelPolicyBuilder",
  components: {
    BasicDetails,
    Rules,
    CustomRules,
    Actions,
    Summary,
  },
  data() {
    return {
      isLoading: false,
      policy: {},
      sfTravelPolicy: null,

      travelPolicy: {
        id: "",
        cabinOptions: [],
        rules: [],
        customRules: [],
      },
      corporateGhostCardOptions: [],

      activeStep: 0,

      showSocial: false,
      isAnimated: true,
      isRounded: true,
      //isStepsClickable: true,

      hasNavigation: false,
      customNavigation: false,
      isProfileSuccess: false,

      labelPosition: "bottom",
      mobileMode: "minimalist",
    };
  },
  methods: {
    getPolicy() {
      this.isLoading = true;

      console.log("Running get policy", this.$route.params);

      var body = {
        accountId: this.profile.account.id,
        travelPolicyId: this.$route.params.id,
        contactId: this.profile.id,
      };

      this.$app
        .huddleLabsServerCall("profile/travel-policy", body)
        .then((result) => {
            console.log(result);
          if (!result.data) {
            this.failure("Error occured processing this request");
            this.$router.push({ path: "/admin/travel-policy" });
          } else {
            this.sfTravelPolicy = result.data;

          }

          //this.sfTravelPolicy = result.data;

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.failure("Error occured processing this request");
          this.$router.push({ path: "/admin/travel-policy" });
        });
    },
    getBasicDetails(val) {
      console.log("Running getBasicDetailsFromBuilder");
      this.travelPolicy = { ...this.travelPolicy, ...val };
      this.travelPolicy.id=this.sfTravelPolicy?this.sfTravelPolicy.id:'';
      this.travelPolicy["ruleClass"] = val.ruleClass;
      this.travelPolicy["corporateGhostCard"] = val.corporateGhostCard;
      this.travelPolicy["allowPersonalPaymentMethods"] =
        val.allowPersonalPaymentMethods;
      this.travelPolicy["ccEmail"] = val.ccEmail;
      this.travelPolicy["allowBasicEconomyFares"] = val.allowBasicEconomyFares;
      this.$set(this.travelPolicy, "cabinOptions", val.cabinOptions);

      // this.travelPolicy["cabinOptions"] = val.cabinOptions;
    },
    getActionData(val) {
      this.travelPolicy["visibility"] = val.visibility;
      this.travelPolicy["approvalLevel"] = val.approvalLevel;
      this.$set(this.travelPolicy, "notifications", val.notifications);
    },
    getRules(val) {
      this.$set(this.travelPolicy, "rules", val.rules);
    },
    getCustomRules(val) {
      this.$set(this.travelPolicy, "customRules", val.rules);
    },
    getCorporateGhostCards() {
      var body = {
        accountId: this.profile.account.id,
        contactId: this.profile.id,
      };

      this.$app
        .huddleLabsServerCall("profile/account/cgc-payment-methods", body)
        .then((result) => {
          this.corporateGhostCardOptions = result.data;
        });
    },
    save() {
      console.log(this.travelPolicy, "final JSON");
      console.log(JSON.stringify(this.travelPolicy));
      this.isLoading = true;

      var body = {
        accountId: this.profile.account.id,
        policy: this.travelPolicy,
        contactId: this.profile.id,
      };

      this.$app
        .huddleLabsServerCall("profile/travel-policy/create", body)
        .then((result) => {
          if (result.success) {
            this.success();
            this.isLoading = false;
            this.$router.push({ path: "/admin/travel-policy" });
          } else {
            this.failure("There was an error saving your travel policy");
            this.isLoading = false;
          }
        });
    },
    handleActiveStep(step) {
      this.scrollToTop();
      switch (this.activeStep) {
        case 0:

          if (this.travelPolicy.ruleClass=='' || (!this.travelPolicy.corporateGhostCard && !this.travelPolicy.allowPersonalPaymentMethods)) {
            this.$buefy.toast.open({
              message: "Please fill out all required fields",
              type: "is-danger",
            });
          } else {
            this.activeStep += step;
          }


          /* if (!this.travelPolicy.ruleClass=='' ) {
            this.activeStep += step;
          } else {
            this.$buefy.toast.open({
              message: "Please fill out all required fields",
              type: "is-danger",
            });
          } */
          break;
        default:
          this.activeStep += step;
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    success() {
      this.$buefy.toast.open({
        message: "Travel policy  sucessfully saved.",
        type: "is-success",
      });
    },
    failure(msg) {
      this.$buefy.toast.open({
        duration: 5000,
        message: msg,
        position: "is-bottom",
        type: "is-danger",
      });
    },
  },
  mounted() {
    this.getCorporateGhostCards();

    if (this.$route.params.id) {
      this.getPolicy();
    }
  },
  computed: {
    profile() {
      return this.$globals.profile;
    },

    isTravelChampion() {
      if (this.profile) return this.profile.isTravelChampion;
      return false;
    },
  },
};
</script>
<style scoped>
.textBold {
  font-weight: bold;
}
.anchar {
  padding-left: 15px;
}
</style>
